import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";

import styled from "styled-components/macro";

import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { sidePadding } from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import ErrorMessage from "Payments/PaymentPage/Shared/ErrorMessage";
import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";

import FnrButton from "UI/FnrButton3";

import useSubmitPayment from "./useSubmitPayment";

export default function SubmitSection() {
  const { state } = usePaymentPage();
  const { paymentParent, addOnAmounts } = state;
  const { fundColorSafe } = state.fund;
  const { submitButtonText } = useGetPaymentTypeVerbiage();
  const [
    { paymentMethodError, submitError, addOnError, formStages, isSubmitting },
    submitPayment,
  ] = useSubmitPayment();

  useEffect(() => {
    // used to give the payments drawer the status of the payment submission
    if (!paymentParent?.syncPaymentIsProcessing) return;
    paymentParent.syncPaymentIsProcessing(isSubmitting);
  }, [isSubmitting, paymentParent]);

  const shouldRender = () => {
    const hasSelectedPaymentMethod = state.selectedPaymentMethodID;
    const isAuthed =
      state.user.loginLevel === "full" || formStages.auth === "skipped";

    return hasSelectedPaymentMethod && isAuthed;
  };

  if (!shouldRender()) return null;

  return (
    <Wrapper>
      <ErrorMessage
        message={paymentMethodError || submitError || addOnError || ""}
      />

      {paymentMethodError || submitError || addOnError ? <Spacer /> : null}

      <FnrButton
        fullWidth
        size="large"
        color={paymentParent?.themeColor || fundColorSafe}
        onClick={() => submitPayment(addOnAmounts)}
        loading={isSubmitting}
        disabled={isSubmitting}
        data-cy="fund-it-submit-button"
      >
        <BtnContent>
          <FontAwesomeIcon icon={faLock} /> {submitButtonText}
        </BtnContent>
      </FnrButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${sidePadding}
  padding-bottom: 10px;

  @media (max-width: 420px) {
    padding-bottom: 0;
  }
`;

const Spacer = styled.div`
  height: 20px;
`;

const BtnContent = styled.div``;
